import React, { Component } from "react";
import MaterialTable from "material-table";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import history from "../../history";
import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import FilterCard from "../filterCard";
import Loader from "../Loader";
import get from "lodash/get";
import BranchDetail from "../../components/BranchDetail";
import { fetchQueryParams } from "../../utils/comman";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
//Redux
import * as sessionActions from "../../redux/moderation/tours/actions";
import * as globalActions from "../../redux/Global/actions";
import { bindActionCreators } from "redux";
import InputText from "../InputText";
import CustomButton from "../CustomButton";
import TourDetails from "../TourDetails";
import AddNewTour from "../AddNewTour";

const _ = { get };

class ToursList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      toggleModal: false,
      toggleAddModal: false,
      selectedId: "",
      page: 0,
      pageSize: 10,
      count: 100,
      category: "TOUR",
      status: "PENDING",
      prevStatus: "PENDING",
      countryCode: "",
      startDate: "",
      endDate: "",
      country: "",
      toggleRejectModal: false,
      rejectionReason: "",
    };
  }

  handleBackCall = () => {
    this.fetchToursList({
      page: this.state.page,
      limit: this.state.count,
      startDate:
        this.state.startDate !== ""
          ? moment(this.state.startDate).format("DD-MM-YYYY")
          : null,
      endDate:
        this.state.endDate !== ""
          ? moment(this.state.endDate).format("DD-MM-YYYY")
          : null,
      status: this.state.status,
      category: this.state.category,
    });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      state.country = e.target.value;
      let parsedValue = this.props.tourCountriesJson.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].locality.country;
      state.countryCode = parsedValue;
    } else {
      state.country = "";
      state.countryCode = "";
    }
    this.setState({ ...state });
  };

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages = this.props.tourList.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.tourList.length !== 0 &&
      this.props.tourList.length < this.props.partnersListCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        email: this.state.email,
        phone: this.state.phone,
      };
      this.handleFetchPartnersList(obj);
      this.fetchToursList({
        page: this.state.page,
        limit: this.state.count,
        startDate:
          this.state.startDate !== ""
            ? moment(this.state.startDate).format("DD-MM-YYYY")
            : null,
        endDate:
          this.state.endDate !== ""
            ? moment(this.state.endDate).format("DD-MM-YYYY")
            : null,
        status: this.state.status,
        category: this.state.category,
      });
    }
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleChangeStatus = (e) => {
    let state = this.state;
    state.prevStatus = state.status;
    state.status = e.target.value;
    this.setState({ ...state });
  };

  handleChangeCategory = (e) => {
    let state = this.state;
    state.category = e.target.value;
    this.setState({ ...state });
  };

  handleRowData = (rowData) => {
    let newState = { ...this.state };
    newState.selectedId = rowData._id;
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleChangeStartDate = (e) => {
    let state = this.state;
    state.startDate = e.target.value;
    this.setState({ ...state });
  };

  handleChangeEndDate = (e) => {
    let state = this.state;
    state.endDate = e.target.value;
    this.setState({ ...state });
  };

  handleGetDetails = (data) => {
    this.props.actions.fetchToursDetail(data);
  };
  fetchToursList = (data) => {
    this.props.actions.fetchToursList(data);
  };
  deleteTourInfo = (data) => {
    this.props.actions.deleteTourInfo(data, this.handleGoBack);
  };

  handleFetchTourCountriesJson = () => {
    this.props.global.fetchingCountriesJson();
  };

  handleGoBack = () => {
    if (
      this.props.usertype === "EU Tours Admin" ||
      this.props.usertype === "Admin"
    ) {
      this.handleRejectModal();
      this.handleToggleModel();
      this.fetchToursList({
        page: this.state.page,
        limit: this.state.count,
        startDate:
          this.state.startDate !== ""
            ? moment(this.state.startDate).format("DD-MM-YYYY")
            : null,
        endDate:
          this.state.endDate !== ""
            ? moment(this.state.endDate).format("DD-MM-YYYY")
            : null,
        status: this.state.status,
        category: this.state.category,
      });
    } else {
      this.handleRejectModal();
      this.handleToggleModel();
      this.fetchToursList({
        page: this.state.page,
        limit: this.state.count,
        startDate:
          this.state.startDate !== ""
            ? moment(this.state.startDate).format("DD-MM-YYYY")
            : null,
        endDate:
          this.state.endDate !== ""
            ? moment(this.state.endDate).format("DD-MM-YYYY")
            : null,
        status: this.state.status,
        category: this.state.category,
      });
    }
  };

  handleSearchFilter = (e) => {
    this.fetchToursList({
      page: this.state.page,
      limit: this.state.count,
      startDate:
        this.state.startDate !== ""
          ? moment(this.state.startDate).format("DD-MM-YYYY")
          : null,
      endDate:
        this.state.endDate !== ""
          ? moment(this.state.endDate).format("DD-MM-YYYY")
          : null,
      status: this.state.status,
      category: this.state.category,
      country: this.state.country,
    });
  };

  handleAddToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleAddModal = !newState.toggleAddModal;
    this.setState({ ...newState });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRejectModal = () => {
    let state = this.state;
    state.toggleRejectModal = !state.toggleRejectModal;
    state.rejectionReason = "";
    this.setState({ ...state });
  };

  handleOnChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleDelete = (e) => {
    let state = this.state;
    let obj = {
      wanderlustId: state.selectedId,
      status: "DELETED",
      rejectionReason: state.rejectionReason,
    };
    this.deleteTourInfo(obj);
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.prevStatus !== this.state.status) {
      this.fetchToursList({
        page: this.state.page,
        limit: this.state.count,
        startDate:
          this.state.startDate !== ""
            ? moment(this.state.startDate).format("DD-MM-YYYY")
            : null,
        endDate:
          this.state.endDate !== ""
            ? moment(this.state.endDate).format("DD-MM-YYYY")
            : null,
        status: this.state.status,
        category: this.state.category,
      });
      let state = this.state;
      state.prevStatus = state.status;
      this.setState({ ...state });
    }
  }

  componentDidMount() {
    let obj = {
      page: this.state.page,
      limit: this.state.count,
      startDate:
        this.state.startDate !== ""
          ? moment(this.state.startDate).format("DD-MM-YYYY")
          : null,
      endDate:
        this.state.endDate !== ""
          ? moment(this.state.endDate).format("DD-MM-YYYY")
          : null,
      status: this.state.status,
      category: this.state.category,
    };
    this.fetchToursList(obj);
    this.handleFetchTourCountriesJson();
  }

  handleClearFilter = () => {
    let state = { ...this.state };
    state.page = 0;
    state.city = "";
    state.pageSize = 10;
    state.status = "PENDING";
    state.endDate = "";
    state.startDate = "";
    state.country = "";
    state.category = "TOUR";
    this.setState({ ...state });
    let data = {
      page: 0,
      city: "",
      limit: 100,
      status: "PENDING",
      category: "TOUR",
      country: "",
      startDate: null,
      endDate: null,
    };
    this.fetchToursList(data);
    this.setState(state);
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        <div className="hideSearch custom-m-table mt-4">
          <Row>
            <Col sm={12}>
              {this.props.usertype &&
              (this.props.usertype === "EU Tours Admin" ||
                this.props.usertype === "Admin") ? (
                <CartTitle
                  title={_.get(
                    elements,
                    "euToursElement.tourListingElements.headingElement",
                    "Tours"
                  )}
                  iconClass={"hideexcel"}
                  Name={_.get(
                    elements,
                    "euToursElement.tourListingElements.filterButtonElement",
                    "Filter"
                  )}
                  handleToggle={() => this.handleToggle()}
                  textTitle={_.get(
                    elements,
                    "euToursElement.tourListingElements.totalCountElement",
                    "Total Count - "
                  )}
                  preRegisteredUserCount={this.props.tourCount}
                />
              ) : (
                <CartTitle
                  title={_.get(
                    elements,
                    "euToursElement.tourListingElements.headingElement",
                    "Tours"
                  )}
                  iconClass={"hideexcel"}
                  Name={_.get(
                    elements,
                    "euToursElement.tourListingElements.addNewElement",
                    "Add New"
                  )}
                  handleToggle={() => this.handleAddToggleModel()}
                  textTitle={_.get(
                    elements,
                    "euToursElement.tourListingElements.totalCountElement",
                    "Total Count - "
                  )}
                  preRegisteredUserCount={this.props.tourCount}
                />
              )}
            </Col>

            {this.state.toggleActive &&
              this.props.usertype &&
              (this.props.usertype === "EU Tours Admin" ||
                this.props.usertype === "Admin") && (
                <Col sm={12}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row>
                        <Col xl={4} lg={4} md={6} sm={6}>
                          <label class="inputLabel">
                            {_.get(
                              elements,
                              "euToursElement.tourListingElements.countryLabelElement",
                              "Country"
                            )}
                          </label>
                          <FormGroup className=" confirmRiderSelect select_options">
                            {this.props.accessibleCountries &&
                            this.props.accessibleCountries.length === 1 &&
                            this.props.accessibleCountries[0] !== "*" ? (
                              <>
                                <Input
                                  type="select"
                                  name="City"
                                  className="w-100 customeSelectBtn"
                                  onChange={this.handleCountryChange}
                                  value={this.state.country}
                                >
                                  <option value="">
                                    {_.get(
                                      elements,
                                      "euToursElement.tourListingElements.selectCountryElement",
                                      "Select Country"
                                    )}
                                  </option>
                                  {this.props.tourCountriesJson &&
                                    this.props.tourCountriesJson.length > 0 &&
                                    this.props.tourCountriesJson
                                      .sort((a, b) =>
                                        a.name > b.name
                                          ? 1
                                          : b.name > a.name
                                          ? -1
                                          : 0
                                      )
                                      .map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.country}
                                        >
                                          {item.country}
                                        </option>
                                      ))}
                                </Input>
                              </>
                            ) : (
                              <Input
                                type="select"
                                name="City"
                                className="w-100 customeSelectBtn"
                                onChange={this.handleCountryChange}
                                value={this.state.country}
                              >
                                <option value="">
                                  {_.get(
                                    elements,
                                    "euToursElement.tourListingElements.selectCountryElementt",
                                    "Select Country"
                                  )}
                                </option>
                                {this.props.tourCountriesJson &&
                                  this.props.tourCountriesJson.length > 0 &&
                                  this.props.tourCountriesJson
                                    .sort((a, b) =>
                                      a.name > b.name
                                        ? 1
                                        : b.name > a.name
                                        ? -1
                                        : 0
                                    )
                                    .map((item, index) => (
                                      <option key={index} value={item.country}>
                                        {item.country}
                                      </option>
                                    ))}
                              </Input>
                            )}
                          </FormGroup>
                        </Col>
                        <Col xl={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "euToursElement.tourListingElements.startDateElement",
                              "Start Date"
                            )}
                            inputType={"date"}
                            inputName={"firstName"}
                            customValue={this.state.startDate}
                            InputClass={"inputText mb-0"}
                            customOnChange={this.handleChangeStartDate}
                          />
                        </Col>
                        <Col xl={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "euToursElement.tourListingElements.endDateElement",
                              "End Date"
                            )}
                            inputType={"date"}
                            inputName={"firstName"}
                            customValue={this.state.endDate}
                            InputClass={"inputText mb-0"}
                            customOnChange={this.handleChangeEndDate}
                            customMin={this.state.startDate}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          lg={12}
                          className="d-flex align-items-center justify-content-end"
                        >
                          <div className="d-flex mt-3">
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "euToursElement.tourListingElements.searchButtonElement",
                                "Search"
                              )}
                              customClass={
                                "btn-outline-dark ml-2 bg-none btnthemeColor"
                              }
                              customClick={this.handleSearchFilter}
                            />
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "euToursElement.tourListingElements.clearFilterButtonElement",
                                "Clear Filter"
                              )}
                              customClass={
                                "btn-outline-dark ml-2 bg-none btnthemeColor"
                              }
                              customClick={this.handleClearFilter}
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )}
            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col xl={3} lg={3} md={6} sm={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.tourListingElements.statusLabelElement",
                          "Status"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          value={this.state.status}
                          onChange={this.handleChangeStatus}
                        >
                          <option value="PENDING">
                            {_.get(
                              elements,
                              "euToursElement.tourListingElements.pendingElement",
                              "Pending"
                            )}
                          </option>
                          <option value="APPROVED">
                            {_.get(
                              elements,
                              "euToursElement.tourListingElements.approvedElement",
                              "Approved"
                            )}
                          </option>
                          <option value="REJECTED">
                            {_.get(
                              elements,
                              "euToursElement.tourListingElements.rejectedElement",
                              "Rejected"
                            )}
                          </option>
                          <option value="MODIFIED">
                            {_.get(
                              elements,
                              "euToursElement.tourListingElements.modifiedElement",
                              "Modified"
                            )}
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <MaterialTable
                title=""
                columns={
                  this.props.usertype === "EU Tours Admin" ||
                  this.props.usertype === "Admin"
                    ? [
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.partnerNameElement",
                            "Partner"
                          ),
                          field: "partnerId.name",
                          render: (rowData) =>
                            rowData &&
                            rowData.partnerId &&
                            rowData.partnerId.name,
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.emailElement",
                            "Email"
                          ),
                          field: "partnerId.email",
                          render: (rowData) =>
                            rowData &&
                            rowData.partnerId &&
                            rowData.partnerId.email,
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.tourNameElement",
                            "Tour Name"
                          ),
                          field: "name",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.countryLabelElement",
                            "Country"
                          ),
                          field: "country",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.startLocationElement",
                            "Start Location"
                          ),
                          field: "startPoint",
                          render: (rowData) =>
                            rowData &&
                            rowData.startPoint &&
                            rowData.startPoint.name,
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.endLocationElement",
                            "End Location"
                          ),
                          field: "endPoint",
                          render: (rowData) =>
                            rowData &&
                            rowData.endPoint &&
                            rowData.endPoint.name,
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.startDateElement",
                            "Start Date"
                          ),
                          field: "startDate",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.endDateElement",
                            "End Date"
                          ),
                          field: "endDate",
                        },
                      ]
                    : [
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.nameElement",
                            "Name"
                          ),
                          field: "name",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.countryLabelElement",
                            "Country"
                          ),
                          field: "country",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.startLocationElement",
                            "Start Location"
                          ),
                          field: "startPoint",
                          render: (rowData) =>
                            rowData &&
                            rowData.startPoint &&
                            rowData.startPoint.name,
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.endLocationElement",
                            "End Location"
                          ),
                          field: "endPoint",
                          render: (rowData) =>
                            rowData &&
                            rowData.endPoint &&
                            rowData.endPoint.name,
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.startDateElement",
                            "Start Date"
                          ),
                          field: "startDate",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.endDateElement",
                            "End Date"
                          ),
                          field: "endDate",
                        },
                        {
                          title: _.get(
                            elements,
                            "euToursElement.tourListingElements.descriptionElement",
                            "Description"
                          ),
                          field: "description",
                          render: (rowData) => (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  rowData.description.length > 100
                                    ? rowData.description
                                        .substring(0, 100)
                                        .concat("...")
                                    : rowData.description,
                              }}
                            />
                          ),
                        },
                      ]
                }
                data={this.props.tourList}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: "Detail Page",
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "euToursElement.tourListingElements.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "euToursElement.euCustomMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "euToursElement.euCustomMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "euToursElement.euCustomMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "euToursElement.tourListingElements.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </Col>
          </Row>
          <Modal
            isOpen={this.state.toggleModal}
            toggle={this.handleToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <TourDetails
                selectedId={this.state.selectedId}
                tourDetails={this.props.tourDetails}
                handleBackCall={this.handleBackCall}
                handleGetDetails={this.handleGetDetails}
                handleToggleModel={this.handleToggleModel}
                handleRejectModal={this.handleRejectModal}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.toggleAddModal}
            toggle={this.handleAddToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <AddNewTour
                handleToggleModel={this.handleAddToggleModel}
                fetchList={this.fetchToursList}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.toggleRejectModal}
            backdrop={true}
            centered={true}
          >
            <ModalHeader toggle={this.handleRejectModal}>
              {_.get(
                elements,
                "euToursElement.tourListingElements.rjectionModelLabel",
                "Rejection Reason"
              )}
            </ModalHeader>
            <ModalBody>
              <InputText
                inputType={"textarea"}
                inputName={"rejectionReason"}
                customValue={this.state.rejectionReason}
                customOnChange={(e) => this.handleOnChange(e)}
              />
            </ModalBody>
            <ModalFooter>
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.tourListingElements.rejectModelButtonElement",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => this.handleDelete(e)}
              />
            </ModalFooter>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    global: bindActionCreators(globalActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    tourList: state.Tours.toursList,
    tourCount: state.Tours.toursListCount,
    tourDetails: state.Tours.toursDetails,
    usertype: state.Auth.usertype,
    tourCountriesJson: state.Global.tourCountriesJson,
    elements: state.Elements.elements,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ToursList)
);
